import React from "react";
import { getDemStatusIconAndColor } from "../logics/demands";
interface IDemandStatus {
  statusName: string | null;
  add2Class: string;
  statusId: number;
}

export const DemandStatus = ({
  statusName,
  add2Class,
  statusId,
}: IDemandStatus) => {
  const { icon, color } = getDemStatusIconAndColor(statusId.toString());

  return (
    <div className={"d-flex  " + add2Class}>
      <img
        src={icon}
        style={{ color: color, width: "25px" }}
        alt="статус_заявки.jpg"
      />
      <div
        className="mr-auto mb-auto mt-auto pl-2"
        style={{
          color: color,
          fontFamily: "SF Pro Display",
          fontWeight: "bold",
        }}
      >
        {statusName}
      </div>
    </div>
  );
};
